import axios from 'axios';
import { autoLogOutTimeSet } from '@common/helpers/auto-logout';

const isDevelopment = process.env.NODE_ENV === 'development';
const baseURL = isDevelopment ? 'http://localhost:3002/api' : '/api';

const axiosInstance = axios.create({ baseURL, timeout: 75000 });

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('tsm-transporter-token');
  const optVerified = localStorage.getItem('otp-verified');
  // const isLogin = window.location.pathname === '/login';
  if ((token && token !== 'undefined')) { // && !isLogin) {
    if ((optVerified === 'true') || (optVerified === null) || (config.url === '/verify_otp') || (config.url === '/generate_otp')) {
      config.headers = { Authorization: `bearer ${token}` };
    }
  }
  return config;
}, error => Promise.reject(error));

axiosInstance.interceptors.response.use((response) => {
  const token = response.headers['x-auth-token'] || response.headers['temp-auth-token'];
  autoLogOutTimeSet(response.status);
  if (token) {
    localStorage.setItem('tsm-transporter-token', token);
  }
  return response.data;
}, error => Promise.reject(error.response));

export default axiosInstance;
